var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotAirBalloonIcon = function SvgHotAirBalloonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171C1F",
    d: "M17.392 3.511a8.58 8.58 0 1 0 2.511 6.066V9.55a8.49 8.49 0 0 0-2.511-6.038M5.413 9.576c0-4.101 2.55-7.51 5.915-8.239 3.365.729 5.914 4.144 5.914 8.24 0 4.094-2.55 7.51-5.914 8.238-3.369-.73-5.915-4.139-5.915-8.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#171C1F",
    d: "M13.959 9.576v-.17c0-2.927-.987-5.624-2.647-7.774l.022.03a13.16 13.16 0 0 0-2.623 7.914c0 2.982.985 5.734 2.648 7.949l-.025-.034a12.64 12.64 0 0 0 2.625-7.74v-.184zm-.02 8.868h-.677a.357.357 0 0 0-.356.342v.955H9.753v-.954a.356.356 0 0 0-.356-.343h-.012.001-.682a.42.42 0 0 0-.42.412l.298 3.734a.43.43 0 0 0 .43.411h4.65a.42.42 0 0 0 .421-.411v-.001l.299-3.733a.42.42 0 0 0-.42-.412l-.024.001h.001"
  })));
};
export default SvgHotAirBalloonIcon;